import type { FC, ReactNode } from 'react'

interface StarburstProps {
    className?: string
}

// Twelve-point burst, the Wallop brand mark. Inherits its color from `currentColor`.
const POINTS = '50,0 59.32,15.23 75,6.7 75.46,24.54 93.3,25 84.77,40.68 100,50 84.77,59.32 93.3,75 75.46,75.46 75,93.3 59.32,84.77 50,100 40.68,84.77 25,93.3 24.54,75.46 6.7,75 15.23,59.32 0,50 15.23,40.68 6.7,25 24.54,24.54 25,6.7 40.68,15.23'

const Starburst: FC<StarburstProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 100 100'
            aria-hidden='true'
            focusable='false'
            className={className}
        >
            <polygon points={POINTS} fill='currentColor' />
        </svg>
    )
}

export default Starburst
